import { useEffect, useState } from "react";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import { useTranslation } from "react-i18next";
import TkWireCamSuperDrillDialog from "../dialogTypes/TkWireCamSuperDrillDialog";

function TkCreateWireCamSuperDrillButton ( props ) {

    const { t } = useTranslation();

    const { id, refresh, onSuccess, onSelectMst, customizeErrorMsgCallback, ...others } = props;

    const [ open, setOpen ] = useState(false);

    const [schema, setSchema] = useState();

    useEffect(()=> {

        let schema = {

            name: "WireWork",
            type: "BASE TABLE",
            searchAll: false,
            columns: [
    
                {
                    name: "num",
                    type: "int(11)",
                    formOrder: 1,
                    formItemType: "number",
                    required : true,
                },
                /* {
                    name: "workTime",
                    type: "int(11)",
                    formOrder: 5,
                    required : true,
                    formItemType: "autocomplete",
                    codeInfo: {
                        tableName: "TimeToSecond",
                        nameColumn: ["timeName"],
                        valueColumn: "second",
                    },
                }, */
                /* {
                    name: "workers",
                    formOrder: 10,
                    hideInForm: false,
                    formGroup: 0,
                    formItemType: "multipleAutocomplete",
                    required : true,
                    codeInfo: {
                        tableName: "User",
                        nameColumn: ["fullName"],
                        valueColumn: "username",
                        useEmptyValue: false,
                        sortByName: true,
                    },
                    width : "100%"
                }, */
    
            ]
        };
        
        setSchema(schema);

    },[])

    const onOpen = () => {

        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onCreateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );

        }

        refresh.refresh ();

    };

    return (

        <>
            <CreateRecordButtonLayout id={id+"create-tkwire"} onClick={onOpen} {...others} />
            <TkWireCamSuperDrillDialog
                id={id+"create-tkwire-cam-superdrill-dialog"}
                mode="create"
                formId={id+"create-tkwire-cam-superdrill-form"}
                title={schema ? t(`dialog.title.${id}.wireCamSuperDrill.create`) : ""}
                schema = {schema}
                onSelectMst = {onSelectMst}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
            />
        </>

    );
}

export default TkCreateWireCamSuperDrillButton;

